import { createContext, ReactNode, useContext } from 'react';

const HostElementContext = createContext<HTMLElement | null>(null);

interface HostElementProviderProps {
  readonly host: HTMLElement;
  readonly children: ReactNode;
}

function HostElementProvider({ host, children }: Readonly<HostElementProviderProps>) {
  return <HostElementContext.Provider value={host}>{children}</HostElementContext.Provider>;
}

function useHostElement<T extends HTMLElement = HTMLElement>(): T {
  const host = useContext(HostElementContext);
  if (!host) {
    throw new Error('useHostElement must be used within a HostElementProvider');
  }
  return host as T;
}

export { HostElementProvider, useHostElement };
